import './Delta.scss';

import React from 'react';
import { ArrowUpRight } from '../components/Icons';

const initiatives = [
  {
    id: '1',
    name: 'Team sponsorships',
    message: 'We currently sponsor two players on a local lacrosse team. These resources help fund the team as they continue to grow and make us proud.',
    img: '/imgs/teams.png',
  },
  {
    id: '2',
    name: 'KidSport Foundation',
    message: 'We are a proud contributor to the KidSport Foundation. We believe every child deserves the opportunity to participate.',
    link: { href: 'http://www.kidsportcanada.ca/', label: 'Visit KidSport' },
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMyiJ41I2OVRq0RZwvQvNdsU-AWJn-8cKfVI6hOZkoJg&s',
  },
  {
    id: '3',
    name: 'Ladner May Days parade',
    message: 'Ivy League Painting has been an active participant in the Ladner May Days parade since 2017.',
    img: 'https://images-ext-1.discordapp.net/external/SL6x2SDE6_qa6tY97alnHmRe96PCEvCeGd2A2Fu6uYM/https/static.wixstatic.com/media/520d3c_ae8aaf678ac948fe8fb3ee3daaee935a~mv2.jpg/v1/fill/w_276%2Ch_356%2Cal_tl%2Cq_80%2Cusm_0.66_1.00_0.01%2Cenc_auto/520d3c_ae8aaf678ac948fe8fb3ee3daaee935a~mv2.jpg?format=webp',
  },
];

const d = (ms: number) => ({ '--delay': `${ms}ms` } as React.CSSProperties);

export function Delta() {
  return (
    <section id="delta" className="section section--grey community">
      <div className="container">
        <div className="head head--center">
          <span className="eyebrow reveal">Giving back</span>
          <h2 className="reveal" style={d(80)}>
            We Love Delta.
          </h2>
          <p className="lede reveal" style={d(160)}>
            We don't only keep your property in top shape, but our whole community too. We're founded and operated
            locally, so we make sure to leave our mark.
          </p>
        </div>

        <ul className="community__list">
          {initiatives.map((i, idx) => (
            <li key={i.id} className="cause reveal" style={d(idx * 90)}>
              <div className="cause__media">
                <img src={i.img} alt={i.name} loading="lazy" />
              </div>
              <h3>{i.name}</h3>
              <p>{i.message}</p>
              {i.link && (
                <a className="cause__link" href={i.link.href} target="_blank" rel="noopener noreferrer">
                  {i.link.label} <ArrowUpRight />
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
